import { useContext } from "react";
import Box from "@mui/material/Box";
import { Spinner } from "../../../components";
import AuthContext from "../../../context/AuthContext";
import { ReportsAdmin } from "./ReportsAdmin";
import { ReportsClient } from "./ReportsClient";

export const ReportsPage = () => {
  const { idRole, isLoading } = useContext(AuthContext);
  if (isLoading) return <Spinner />;

  return (
    <Box sx={{ mt: "-80px", minHeight: "100vh", bgcolor: "#F3F3F0" }}>
      {idRole === 3 ? <ReportsClient /> : <ReportsAdmin />}
    </Box>
  );
};
